import React, { useEffect } from "react";
import { Navigate, useSearchParams } from "react-router";
import { confirmPlanChange } from "@/stores/usePendingCheckoutStore";

/// Return URL for a buyer the processor navigated (a bookmarked return, a
/// wallet completing out-of-page); the ordinary path is the inline checkout's
/// completion event.
export const BillingWelcomePage: React.FC = () => {
  const [params] = useSearchParams();
  const orgId = params.get("org_id") ?? undefined;
  const previousCode = params.get("from") ?? "";

  useEffect(() => {
    if (orgId) confirmPlanChange(orgId, previousCode);
  }, [orgId, previousCode]);

  return (
    <Navigate
      to={orgId ? `/organizations/${orgId}#plan` : "/overview"}
      replace
    />
  );
};
